import { render, staticRenderFns } from "./SendText.vue?vue&type=template&id=63b73623&"
import script from "./SendText.vue?vue&type=script&lang=js&"
export * from "./SendText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports